import React, { useState, useEffect, useCallback } from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ListSubheader from "@mui/material/ListSubheader";
import RemoveCircleOutlinedIcon from "@mui/icons-material/RemoveCircleOutlined";

import { useGlobalSpinnerActionsContext } from "./../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "./../../../Context/LanguageContext";
import { useAMGSelectedContext } from "./../../../Context/GlobalContext";

import tabsactions from "./../../../Actions/TabsActions";
import tabsconstant from "./../../../Constants/TabsConstants";
import tabsstore from "./../../../Stores/TabsStore";
import TabsActions from "./../../../Actions/TabsActions";
import tabsStore from "./../../../Stores/TabsStore";
import { toast } from "react-toastify";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import Typography from "@mui/material/Typography";
import EquipDetailHeader from "../../ReusableComponent/equipDetailHeader";
import FileUploadDragDrop from "../../ReusableComponent/FileUploadDragDrop";
import ImageListView from "../../Equipment-Details/ImageListView";
import EquipmentActions from "../../../Actions/EquipmentActions";
import equipmentStore from "../../../Stores/EquipmentStore";
import EquipmentContants from "../../../Constants/EquipmentConstants";
import { Button } from "@mui/material";

const BilderUebersicht = ({ anlageid, handleTourGuid }) => {
  //--context
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();

  const [data, setData] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [isImageShow, setIsImageShow] = useState(false);
  const [frame, setFrame] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showFileUploadDialog, setShowFileUploadDialog] = useState(false);
  const [showImageListView, setShowImageListView] = useState(false);

  const base64toblob = (base64) => {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; ++i) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return new Blob([bytes], { type: "jpg" });
  };

  const fetchData = useCallback(() => {
    setGlobalSpinner(true);

    if (anlageid !== null && anlageid !== undefined) {
      tabsactions.getAnlageBild(anlageid);
    }
  }, [anlageid]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    function updateData() {
      var _res = tabsstore.getResult();
      let tempArr = _res.filter((item, index) => {
        return item.documentAsString != null && item.documentAsString != "";
      });
      setData(tempArr);
      handleTourGuid(3);
      setGlobalSpinner(false);
    }

    tabsstore.addChangeListener(tabsconstant.GET_BILD_SUCCESS, updateData);

    return () => {
      tabsstore.removeChangeListener(tabsstore.GET_BILD_SUCCESS, updateData);
    };
  }, []);

  useEffect(() => {
    function updateData() {
      setData(null);
      setGlobalSpinner(false);
    }

    tabsstore.addChangeListener(tabsconstant.GET_BILD_FAILURE, updateData);

    return () => {
      tabsstore.removeChangeListener(tabsstore.GET_BILD_FAILURE, updateData);
    };
  }, []);

  useEffect(() => {
    let image = [];

    if (data !== null && data !== undefined) {
      data.map((item, index) => {
        if (item.documentAsString) {
          image.push(`data:image/jpg;base64,${item.documentAsString}`);
        }
      });

      setImageSrc(image);
    } else {
      setImageSrc(null);
    }

    //  setImageSrc(dataUrl);
  }, [data]);
  let _renderMe = "";

  if (data !== null && data !== undefined) {
    _renderMe = data.map((image, index) => {
      return (
        <>
          <img
            src={"data:image/jpg;base64," + image.documentAsString}
            alt={localization.BildNotFound}
            //style={{ height: "30%", width: "30%", border: "none" }}
          />
        </>
      );
    });
  } else {
    _renderMe = null;
  }

  const updateImages = (id) => {
    setGlobalSpinner(true);
    TabsActions.deleteDocument(id);
  };

  useEffect(() => {
    function updateData() {
      toast.success(localization.imageDeleteSuccess);
      fetchData();
    }

    tabsStore.addChangeListener(
      tabsconstant.DELETE_DOCUMENT_SUCCESS,
      updateData
    );

    return () => {
      tabsStore.removeChangeListener(
        tabsconstant.DELETE_DOCUMENT_SUCCESS,
        updateData
      );
    };
  }, []);

  useEffect(() => {
    function setDefaultImageSuccess() {
      var res = equipmentStore.getResult();
      if (res) {
        toast.success(localization.defaultImageSetSuccess);
      }
      fetchData();
    }

    function setDefaultImageError() {
      var res = equipmentStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    equipmentStore.addChangeListener(
      EquipmentContants.SET_EQUIPMENT_DEFAULT_IMAGE_SUCCESS,
      setDefaultImageSuccess
    );

    equipmentStore.addChangeListener(
      EquipmentContants.SET_EQUIPMENT_DEFAULT_IMAGE_FAILURE,
      setDefaultImageError
    );
    return () => {
      equipmentStore.removeChangeListener(
        EquipmentContants.SET_EQUIPMENT_DEFAULT_IMAGE_SUCCESS,
        setDefaultImageSuccess
      );

      equipmentStore.removeChangeListener(
        EquipmentContants.SET_EQUIPMENT_DEFAULT_IMAGE_FAILURE,
        setDefaultImageError
      );
    };
  }, []);

  function handleLightBox(e, _value) {
    e.preventDefault();
    setSelectedImage(_value);
    setIsImageShow(true);
  }

  const uploadBtnCallBack = () => {
    setShowFileUploadDialog(true);
  };

  const handleUpload = (fileData) => {
    setGlobalSpinner(true);
    if (fileData.filetoStringarray.length > 0) {
      let obj = {
        AnlageId: anlageid,
        DocumentType: "bild",
        EquipmentPhotos: fileData.filetoStringarray,
      };
      EquipmentActions.SaveUpdateEquipmentPicture(obj);
    } else {
      setGlobalSpinner(false);
    }
  };

  useEffect(() => {
    function saveImagesSuccess() {
      toast.success(localization.imagesUploadSuccess);
      setShowFileUploadDialog(false);
      tabsactions.getAnlageBild(anlageid);
    }

    function saveImagesError() {
      toast.error(localization.documentSaveError);
      setGlobalSpinner(false);
    }

    equipmentStore.addChangeListener(
      EquipmentContants.SAVE_EQUIPMENT_IMAGES_SUCCESS,
      saveImagesSuccess
    );

    equipmentStore.addChangeListener(
      EquipmentContants.SAVE_EQUIPMENT_IMAGES_FAILURE,
      saveImagesError
    );
    return () => {
      equipmentStore.removeChangeListener(
        EquipmentContants.SAVE_EQUIPMENT_IMAGES_SUCCESS,
        saveImagesSuccess
      );

      equipmentStore.removeChangeListener(
        EquipmentContants.SAVE_EQUIPMENT_IMAGES_FAILURE,
        saveImagesError
      );
    };
  }, []);

  return (
    <>
      <div className="container-fluid equipDetailContainer p-5 mt-3">
        <div className="row justifyContentSpaceBetw">
          <EquipDetailHeader
            title={localization.equipmentImages}
            description={localization.photosAndImagesOfEquipment}
            buttonTitle={localization.uploadImages}
            onClickHandler={uploadBtnCallBack}
            hideButtonFlag={false}
          />
        </div>

        <div className="equipmentImgList mt-5">
          {data !== null && data !== undefined && data.length > 0 ? (
            <>
              <ImageList sx={{ height: 500 }} rowHeight={300} cols={4} gap={10}>
                {data.map((image, index) => {
                  return image.documentAsString ? (
                    <>
                      <ImageListItem key={index}>
                        <img
                          src={
                            "data:image/jpg;base64," + image.documentAsString
                          }
                          alt={""}
                          className="thumbnail"
                          loading="lazy"
                          onClick={(e) => handleLightBox(e, index)}
                        />

                        <span
                          className="zoomInIconCls"
                          onClick={(e) => handleLightBox(e, index)}
                        >
                          <ZoomInIcon />
                        </span>
                      </ImageListItem>
                    </>
                  ) : (
                    <></>
                  );
                })}
              </ImageList>
            </>
          ) : (
            <>
              <div className="text-center">{localization.noImageAvailable}</div>
            </>
          )}

          {isImageShow &&
            (imageSrc.length === 1 ? (
              <Lightbox
                allowReset={true}
                onClose={() => {
                  setIsImageShow(false);
                }}
                image={imageSrc[0]}
              ></Lightbox>
            ) : (
              <Lightbox
                allowReset={true}
                onClose={() => {
                  setIsImageShow(false);
                }}
                images={imageSrc}
                startIndex={selectedImage}
              ></Lightbox>
            ))}
        </div>
        {data !== null && data !== undefined && data.length > 0 && (
          <div className="text-center mt-4">
            <Button
              variant="contained"
              className="containedBtnCls"
              sx={{ textTransform: "none" }}
              size="large"
              fullWidth
              onClick={() => {
                setShowImageListView(true);
              }}
            >
              {localization.manageAllImages}
            </Button>
          </div>
        )}
      </div>
      {showFileUploadDialog && (
        <FileUploadDragDrop
          isOpen={showFileUploadDialog}
          setShowFileUploadDialog={setShowFileUploadDialog}
          title={localization.uploadNewImages}
          description={localization.uploadImagesToAssociate}
          dragAndDropTitle={localization.dragAndDropImagesHere}
          browseButtonTitle={localization.browseImages}
          type="Images"
          uploadHandler={handleUpload}
        />
      )}

      {showImageListView && (
        <ImageListView
          isOpen={showImageListView}
          imageData={data}
          setShowImageListView={setShowImageListView}
          setShowFileUploadDialog={setShowFileUploadDialog}
          handleLightBox={handleLightBox}
          updateImages={updateImages}
        />
      )}
    </>
  );
};
export default BilderUebersicht;
